module.exports = __webpack_public_path__ + "img/logo-salesflow.226efdb8.png";